(() => {
  const popup = document.getElementById('ferreti-ba-popup');
  const teaser = document.getElementById('ferreti-ba-popup-teaser');
  if (!popup || !teaser || typeof popup.showModal !== 'function') return;

  const end = Date.parse(popup.dataset.campaignEnd);
  if (!Number.isFinite(end) || Date.now() >= end) return;
  const storageKey = 'ferreti_black_alucin_popup_seen_2026';
  const cooldown = 24 * 60 * 60 * 1000;
  const preview = new URLSearchParams(window.location.search).get('black_alucin_preview') === '1';
  const isRegistered = () => {
    if (preview) return false;
    try { return localStorage.getItem('ferreti_black_alucin_vip') === '1'; }
    catch (_) { return false; }
  };
  if (isRegistered()) return;

  const cta = popup.querySelector('[data-ba-cta]');
  const form = popup.querySelector('[data-ba-register]');
  const status = popup.querySelector('[data-ba-status]');
  const country = form.elements.country;
  const whatsapp = form.elements.whatsapp_consent;
  const sms = form.elements.sms_consent;
  const smsDisclosure = popup.querySelector('[data-ba-sms-disclosure]');
  const syncCountry = () => {
    const smsEnabled = country.value === 'US';
    popup.querySelector('[data-ba-sms]').hidden = !smsEnabled;
    smsDisclosure.hidden = !smsEnabled;
    sms.disabled = !smsEnabled;
    if (!smsEnabled) sms.checked = false;
    const enabled = country.value === 'MX';
    popup.querySelector('[data-ba-whatsapp]').hidden = !enabled;
    whatsapp.disabled = !enabled;
    if (!enabled) whatsapp.checked = false;
  };
  country.addEventListener('change', syncCountry);
  syncCountry();
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (cta.disabled || !form.reportValidity()) return;
    status.textContent = '';
    const phoneRaw = form.elements.phone.value.trim();
    let phone;
    if (phoneRaw) {
      const digits = phoneRaw.replace(/\D/g, '');
      const prefix = country.value === 'MX' ? '52' : '1';
      const national = digits.length === 10 ? digits : digits.startsWith(prefix) ? digits.slice(prefix.length) : '';
      if (national.length !== 10) { status.textContent = 'Revisa el teléfono: escribe los 10 dígitos de tu número.'; return; }
      phone = `+${prefix}${national}`;
    }
    if (whatsapp.checked && !phone) { status.textContent = 'Añade tu teléfono para recibir mensajes por WhatsApp.'; return; }
    if (sms.checked && !phone) { status.textContent = 'Añade tu celular para recibir promociones por SMS, o desmarca la casilla para continuar solo por email.'; return; }
    const smsConsent = country.value === 'US' && sms.checked && Boolean(phone);
    const whatsappConsent = country.value === 'MX' && whatsapp.checked && Boolean(phone);
    const registeredAt = new Date().toISOString();
    const subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (smsConsent) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    if (whatsappConsent) subscriptions.whatsapp = { marketing: { consent: 'SUBSCRIBED' } };
    const properties = {
      VIP_Black_Friday_2026: true, Campana: 'EL BLACK ALUCIN 3X2', Fecha_Registro: registeredAt,
      BA26_Phone_Country: country.value, BA26_WhatsApp_Opt_In: whatsappConsent,
      BA26_Registration_Source: 'Storefront inline popup',
    };
    if (smsConsent) {
      properties.BA26_SMS_Consent_Date = registeredAt;
      properties.BA26_SMS_Consent_Source = 'Storefront inline popup';
      properties.BA26_SMS_Consent_Version = '2026-10-23-v1';
      properties.BA26_SMS_Consent_Text = smsDisclosure.textContent.trim();
      properties.BA26_SMS_Terms_URL = 'https://ferretihats.com/pages/sms-terms-of-service';
    }
    if (whatsappConsent) {
      properties.BA26_WhatsApp_Consent_Date = registeredAt;
      properties.BA26_WhatsApp_Consent_Source = 'Storefront inline popup';
    }
    cta.disabled = true;
    cta.textContent = 'REGISTRANDO…';
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Wpb7nV', {
        method: 'POST', headers: { revision: '2026-07-15', 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Black Alucin - todas las gorras', profile: { data: { type: 'profile', attributes: {
            email: form.elements.email.value.trim(), first_name: form.elements.first_name.value.trim() || undefined,
            phone_number: phone, subscriptions, properties,
          } } },
        }, relationships: { list: { data: { type: 'list', id: 'V7ppCT' } } } } }),
      });
      if (!response.ok) throw new Error('No pudimos completar el registro. Intenta de nuevo.');
      try { localStorage.setItem('ferreti_black_alucin_vip', '1'); } catch (_) { /* Keep the confirmation without storage. */ }
      status.textContent = smsConsent ? 'Registro recibido. Revisa tu celular y confirma la suscripción si recibes una solicitud de confirmación.' : 'Ya estás registrado';
      cta.textContent = 'YA ESTÁS REGISTRADO';
      teaser.hidden = true;
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Black Alucin - novedades y ofertas' });
      document.dispatchEvent(new CustomEvent('ba26:registration-confirmed'));
      window.setTimeout(close, smsConsent ? 6000 : 1600);
    } catch (error) {
      status.textContent = error.message;
      cta.disabled = false;
      cta.textContent = 'RECIBIR NOVEDADES Y OFERTAS ↗';
    }
  });
  const remember = () => {
    try { localStorage.setItem(storageKey, String(Date.now())); }
    catch (_) { /* A blocked storage must not prevent closing. */ }
  };
  const show = () => {
    if (popup.open || isRegistered() || Date.now() >= end) return;
    const anotherModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]'))
      .some((element) => {
        const details = element.closest('details');
        if (details && !details.open) return false;
        const bounds = element.getBoundingClientRect();
        return getComputedStyle(element).visibility !== 'hidden' && bounds.width > 0 && bounds.height > 0 &&
          bounds.right > 0 && bounds.bottom > 0 && bounds.left < window.innerWidth && bounds.top < window.innerHeight;
      });
    if (anotherModal) return;
    popup.querySelectorAll('[data-ba-image]').forEach((image) => {
      if (!image.src) image.src = image.dataset.baImage;
    });
    popup.showModal();
    document.documentElement.classList.add('ferreti-ba-popup-open');
    remember();
  };
  const close = () => popup.close();
  popup.querySelector('[data-ba-close]').addEventListener('click', close);
  popup.addEventListener('close', () => {
    document.documentElement.classList.remove('ferreti-ba-popup-open');
    remember();
  });
  popup.addEventListener('click', (event) => {
    const bounds = popup.getBoundingClientRect();
    if (event.target === popup && (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
  });
  cta.addEventListener('click', remember);
  teaser.addEventListener('click', show);
  teaser.hidden = false;
  let lastSeen = 0;
  try { lastSeen = Number(localStorage.getItem(storageKey)) || 0; }
  catch (_) { /* Fall back to once for this page. */ }
  if (preview || Date.now() - lastSeen >= cooldown) {
    window.setTimeout(() => {
      if (document.visibilityState === 'visible') show();
    }, 6000);
  }
})();
